import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { useDocumentTitle } from "./hooks/useDocumentTitle";

export function LoadingFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center"
      role="status"
      aria-label="Loading"
    >
      <div className="border-muted border-t-primary h-8 w-8 animate-spin rounded-full border-4" />
    </div>
  );
}

export function Root() {
  useDocumentTitle();

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Outlet />
    </Suspense>
  );
}
